import { create } from 'zustand';

export const useLoader = create((set) => ({
  ready: false,

  setReady: () => set({ ready: true }),
}));
